/**
* Calendar logic
*/

const holidays = require('finnish-holidays-js');
class Calendar {

  /**
  * @constructor
  * @param {HTMLElement} element element to bind to
  */
  constructor( element ) {
    this._form = element;
    this._calendarContainer = element.querySelector('.calendar-container');
    this._submitButton = this._form.querySelector('[type="submit"]');
    this._dateInput = this._form.querySelector('input[name="date"]');

    if (!this._dateInput) {
      this._dateInput = document.createElement('input');
      this._dateInput.type = 'hidden';
      this._dateInput.name = 'date';
      this._calendarContainer.before(this._dateInput);
    }

    this._setCalendar(this._calendarContainer, false, false, false, () => { this._setCalendarCallback(); });
  }

  /**
  * Slide element up
  * @param {HTMLElement} container Calendar container element
  * @param {Number} year Year
  * @param {Number} month Month
  * @param {Array} dates Dates
  * @param {Function} callback Callback
  */
  _setCalendar(container, year = false, month = false, dates = false, callback) {
    const calendarHolder = container;

    const calendar = document.createElement('div');
    calendar.classList.add('calendar');

    const header = document.createElement('div');
    header.classList.add('header');

    const weekdays = document.createElement('div');
    weekdays.classList.add('weekdays');

    const weeks = document.createElement('div');
    weeks.classList.add('weeks');

    const prevMonthBtn = this._createButton();
    prevMonthBtn.classList.add('prev-month','f-icon--chevron-left');

    const nextMonthBtn = this._createButton();
    nextMonthBtn.classList.add('next-month','f-icon--chevron-right');

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const thisYear = year || year === 0 ? year : today.getFullYear();
    const thisMonth = month || month === 0 ? month : today.getMonth();
    const firstDay = new Date(thisYear, thisMonth, 1);
    const prevMonth = firstDay.getMonth() > 0 ? firstDay.getMonth() - 1 : 11;
    const prevYear = prevMonth === 11 ? firstDay.getFullYear() - 1 : firstDay.getFullYear();
    const viewStartDate = firstDay;

    if (viewStartDate.getDay() !== 1) {
      viewStartDate.setDate(firstDay.getDate() - firstDay.getDay() + (firstDay.getDay() === 0 ? -6 : 1));
    }

    const monthNames = ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu']
    const weekDays = ['Ma', 'Ti', 'Ke', 'To', 'Pe', 'La', 'Su'];

    prevMonthBtn.setAttribute('disabled','');

    if (firstDay > today) {
      prevMonthBtn.removeAttribute('disabled');
    }

    header.appendChild(prevMonthBtn);
    const headerHtml = `<div class="year-and-month"><span><span class="month label bold">${monthNames[thisMonth]}</span> <span class="year label bold">${thisYear}</span></span></div>`;
    header.insertAdjacentHTML('beforeend', headerHtml)

    const weekDaysHtml = weekDays.map( day => `<span class="weekday label bold">${day}</span>`).join('');
    weekdays.insertAdjacentHTML('beforeend', weekDaysHtml);

    header.appendChild(nextMonthBtn);

    calendar.appendChild(header);
    calendar.appendChild(weekdays);
    calendar.appendChild(weeks);

    prevMonthBtn.addEventListener('click', e => {
      e.preventDefault();
      this._setCalendar(calendarHolder, prevYear, prevMonth, dates, callback);
    });

    nextMonthBtn.addEventListener('click', e => {
      e.preventDefault();

      const newMonth = parseInt(thisMonth) >= 11 ? 0 : parseInt(thisMonth) + 1;
      const newYear = parseInt(thisMonth) >= 11 ? parseInt(thisYear + 1) : thisYear;

      this._setCalendar(calendarHolder, newYear, newMonth, dates, callback);
    });

    for (let w = 0; w <= 5; w++) {

      if ((thisMonth === 0 ? 11 : thisMonth - 1) === viewStartDate.getMonth() || thisMonth === viewStartDate.getMonth()) {

        const week = document.createElement('div');
        week.classList.add('week');

        for (let d = 0; d <= 6; d++) {

          const day = viewStartDate.getDate();
          const month = viewStartDate.getMonth() + 1;
          const year = viewStartDate.getFullYear();

          const dayElement = document.createElement('button');
          dayElement.classList.add('day', 'button-text');
          dayElement.setAttribute('type', 'button');//Default is submit
          dayElement.setAttribute('data-day', viewStartDate.getDate());
          dayElement.setAttribute('data-month', parseInt(viewStartDate.getMonth() + 1));
          dayElement.setAttribute('data-year', viewStartDate.getFullYear());
          dayElement.innerHTML = viewStartDate.getDate();

          if (viewStartDate.getTime() < today.getTime()) {
            dayElement.classList.add('disabled');
            dayElement.setAttribute('disabled','');
          }

          // Disable all the sundays and holidays, if it's not disabled yet
          if (!dayElement.classList.contains('disabled') && (viewStartDate.getDay() === 0 || this._isHoliday(day, month, year))) {
            dayElement.classList.add('disabled');
            dayElement.setAttribute('disabled','');
          }

          if (!dayElement.classList.contains('disabled') &&
            dates[viewStartDate.getFullYear()] &&
            dates[viewStartDate.getFullYear()][viewStartDate.getMonth()] &&
            dates[viewStartDate.getFullYear()][viewStartDate.getMonth()][viewStartDate.getDate()])
            dayElement.classList.add('available')
              .setAttribute('data-ms', dates[viewStartDate.getFullYear()][viewStartDate.getMonth()][viewStartDate.getDate()].ms);

          week.appendChild(dayElement);

          viewStartDate.setDate(viewStartDate.getDate() + 1);

        }

        calendar.querySelector('.weeks').appendChild(week);
      }

    }

    calendarHolder.innerHTML = '';
    calendarHolder.appendChild(calendar);

    if (callback && typeof callback === 'function') {
      callback();
    }
  }

  /**
   * Create Button element
   * @returns {HTMLButtonElement}
   */
  _createButton() {
    const button = document.createElement('button');
    button.classList.add('hedin-btn', 'hedin-btn--tertiary', 'hedin-btn--large',
      'f-icon', 'f-icon--no-margin');

    button.href = '#';
    button.setAttribute('type', 'button');

    return button;
  }

  _setCalendarCallback() {
    const calendar = this._calendarContainer;
    const dateInput = this._dateInput;

    if (dateInput && dateInput.value !== '' && dateInput.value !== 'NaN') {
      const dateInputVal = new Date(parseInt(dateInput.value));

      const selectedDay = dateInputVal.getDate();
      const selectedMonth = dateInputVal.getMonth() + 1;
      const selectedYear = dateInputVal.getFullYear();

      const calendarDate = this._form.querySelector(`.day[data-day="${selectedDay}"][data-month="${selectedMonth}"][data-year="${selectedYear}"]`);

      if (calendarDate) {
        calendarDate.classList.add('active');
      }

      this._submitButton.removeAttribute('disabled');
    }

    calendar.querySelectorAll('.day').forEach(el => {
      el.addEventListener('click', (event) => { this._onDayClicked(event.target); });
    });
  }

  /**
   * Handle date selection
   * @param {Element} day - Date
   */
  _onDayClicked(day) {
    const calendar = this._calendarContainer;
    const dateInput = this._dateInput;

    if (!day.classList.contains('disabled')) {
      const date = new Date(
        day.getAttribute('data-year') +
          '-' +
          this._setDoubleDigits(day.getAttribute('data-month')) +
          '-' +
          this._setDoubleDigits(day.getAttribute('data-day')),
      );

      calendar.querySelectorAll('.day').forEach(el => { el.classList.remove('active') });
      day.classList.add('active');

      dateInput.value = date.getTime();

      this._submitButton.removeAttribute('disabled');
    }
  }

  /**
   * Add leading zero
   * @param {String|Number} value - Some number
   * @returns {String}
   */
  _setDoubleDigits(value) {
    if (parseInt(value) < 10) {
      return '0' + value;
    }
    return value;
  }


  static init() {
    const form = document.querySelectorAll('form');

    form.forEach( el => {
      if (el.querySelectorAll('.calendar-container').length) {
        new Calendar( el );
      }
    });
  }

  _isHoliday(day, month, year) {
    const availableHolidays = holidays.month(month, year);
    return availableHolidays.some(holiday => holiday.day === day);
  }
}

export default Calendar;
